import { render, staticRenderFns } from "./ReminderListItem.vue?vue&type=template&id=bd45d126&scoped=true&"
import script from "./ReminderListItem.vue?vue&type=script&lang=js&"
export * from "./ReminderListItem.vue?vue&type=script&lang=js&"
import style0 from "./ReminderListItem.vue?vue&type=style&index=0&id=bd45d126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd45d126",
  null
  
)

export default component.exports